import styled from "styled-components";
import { achievements } from "../../../content-options/trophy";
import { FC} from "react";

interface Props {
    quantity: number;
    achievement: string;
}

const Achievement: FC<Props> = ({ achievement, quantity }) => {
    const image = achievements[achievement as keyof typeof achievements];
  return (
    <>
      <Container>
          <Img src={image} />
        <Quantity>{quantity}</Quantity>
      </Container>
    </>
  );
};

export default Achievement;

const Container = styled.div`
  height: 100%;
  aspect-ratio: 1/1;
  //overflow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const Img = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
`;
const Quantity = styled.div`
  position: absolute;
  border: #212121 solid 3px;
  right: -8%;
  bottom: 3%;
  border-radius: 50%;
  background-color: white;
  color: #212121;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;

  height: 33%;
  width: 33%;
  max-height: 30px;
  aspect-ratio: 1/1;
  font-size: small;
  //font-size: clamp(0.5rem, 1vw + 0.5rem, 1rem);

   @media (max-width: 480px ) {
     font-size: x-small;
  } 
`;
